<template>
  <div v-if="items.length" class="m-widget1">
    <div v-for="(item, i) in items" :key="i" class="m-widget1__item">
      <div class="row m-row--no-padding align-items-center">
        <div class="col">
          <h3 class="m-widget1__title">{{ item.label }}</h3>
          <div>
            <span class="m-widget1__number font-ls">{{ item.value }}</span>
            <i v-if="item.info" class="fa fa-info-circle" v-b-tooltip :title="item.info" style="margin-left:5px;line-height:1.5"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: "Client",
    computed: mapState({
      items: state => state.account.items,
    }),
  }
</script>

<style scoped>

</style>
